export default (state = [], action) => {
  switch (action.type) {
    case 'REQUEST_TIPS_PENDING':
      return {
        ...state,
        failureFetching: false,
        isFetching: true,
      };
    case 'FAILURE_TIPS_PENDING':
      return {
        ...state,
        failureFetching: true,
        isFetching: false,
      };
    case 'RECEIVE_TIPS_PENDING':
      return {
        ...state,
        failureFetching: false,
        isFetching: false,
        isFetched: true,
        tips: action.tips,
      };
    default:
      return state;
  }
};
